import * as bootbox from 'bootbox';
import { BootboxStatic } from 'bootbox';
import { TouchSpin } from "./TouchSpin";

export class RenderModal
{
    /**
     * Init a modal
     *
     * @param title
     * @param content
     * @param buttons
     * @param reloadPage
     * @param size
     * @param closeOnBackdropClick
     * @param onHideCallback
     * @param onShowCallback
     */
    public static init(
        title: string|null = null,
        content: string|null = null,
        buttons: string|[]|null = null,
        reloadPage: boolean = false,
        size: string|null = 'large',
        closeOnBackdropClick: boolean|null = false,
        onHideCallback: Function|null = null,
        onShowCallback: Function|null = null
    ): BootboxStatic {
        const box = bootbox.dialog({
            message: content,
            size: (size === null) ? 'large' : size,
            title: title,
            buttons: buttons,
            onEscape: true,
            backdrop: (closeOnBackdropClick === true) ? true : undefined,
            onHide: onHideCallback,
            onShow: onShowCallback
        })

        box.bind('shown.bs.modal', function () {
            TouchSpin.init('input[type="number"]');

            if ($('input').attr('type') === 'text') {
                TouchSpin.init('input.quantity-input');
            }

            // Init lazyembed for external videos
            window.initOverlayLazyEmbed('.bootbox-body .embed-responsive > iframe[data-lazyembed-overlay="video"]');

            const reinitDropdownEvent = new Event('plandent.reinit.bootstrapDropdown');
            document.dispatchEvent(reinitDropdownEvent)
        });

        box.bind('hidden.bs.modal', function () {
            if (reloadPage === true) {
                location.reload();
            }
        });

        return box;
    }
}
